import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicField, FieldVariant, TextFieldProps } from '@/components/form-builder/form-builder.types';
import { PpmRepository } from '@/store/ppm-state/ppm-state.repository';

interface getPPMDownloadDialogProps {
  store: PpmRepository;
  validate: () => void;
}

export const getPPMDownloadDialog = ({ store, validate }: getPPMDownloadDialogProps): DialogObject => {
  const signPersonField: DynamicField<TextFieldProps> = {
    label: 'Signataire',
    variant: FieldVariant.TEXT,
    isRequired: true,
    props: {
      placeholder: 'Entrez le nom du signataire',
      value: store.getNestedObservable('download', 'signPerson'),
      onChange: (value: string) => {
        store.setNested('download', 'signPerson', value);
      },
    },
  };

  const functionField: DynamicField<TextFieldProps> = {
    label: 'Fonction',
    variant: FieldVariant.TEXT,
    isRequired: true,
    props: {
      placeholder: 'Entrez la fonction',
      value: store.getNestedObservable('download', 'function'),
      onChange: (value: string) => {
        store.setNested('download', 'function', value);
      },
    },
  };

  return {
    title: 'Téléchargement',
    actions: [
      {
        label: 'Télécharger',
        variant: 'success',
        onClick: () => validate(),
      },
    ],
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: {
          title: '',
          description: '',
          isHeaderHidden: true,
          class: '',
          grids: [
            {
              title: '',
              isHeaderHidden: true,
              gridItems: [
                {
                  fields: [signPersonField],
                },
                {
                  fields: [functionField],
                },
              ],
            },
          ],
        },
      },
    },
  };
};
